import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { getEntitlements } from '../api/wpClient';

const EntitlementsContext = createContext(null);
export const useEntitlements = () => useContext(EntitlementsContext);

const DEMO_FALLBACK = {
  plan: 'demo',
  features: { export: false, advancedAnalytics: false, apiWrite: false },
  limits: { maxStudents: 20, maxTerms: 2 },
  dataset: 'demo-small',
};

export function EntitlementsProvider({ children, initial = null, onLoad }) {
  const [ent, setEnt] = useState(initial);
  const [loading, setLoading] = useState(!initial);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (initial) {
      onLoad?.(initial);
      return;
    }
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getEntitlements();
        console.log(data);
        if (cancelled) return;
        setEnt(data || DEMO_FALLBACK);
        onLoad?.(data || DEMO_FALLBACK);
      } catch (e) {
        if (cancelled) return;
        setError(e);
        setEnt(DEMO_FALLBACK); // graceful demo fallback
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [initial, onLoad]);

  const value = useMemo(() => {
    const v = ent || DEMO_FALLBACK;
    return { ...v, __loading: loading, __error: error };
  }, [ent, loading, error]);

  return (
    <EntitlementsContext.Provider value={value}>
      {children}
    </EntitlementsContext.Provider>
  );
}
